module.exports = __webpack_public_path__ + "static/img/li7_2.444d1e32.png";